import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { AuthShell } from "@/features/auth/modules/auth-shell/auth-shell";
import { NewPasswordForm } from "@/features/auth/modules/new-password/new-password-form";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/new-password/")({
  staticData: { sitemap: false },
  component: RouteComponent,
  loader: () => {
    return {
      crumb: m.auth_new_password_crumb(),
    };
  },
  validateSearch: z.object({
    token: z.string().optional(),
  }),
});

function RouteComponent() {
  const { token } = Route.useSearch();

  return (
    <AuthShell
      eyebrow={m.auth_new_password_eyebrow()}
      title={{ lead: m.auth_new_password_title_lead(), accent: m.auth_new_password_title_accent() }}
      description={m.auth_new_password_description()}
      aside={{
        prompt: m.auth_new_password_aside_prompt(),
        label: m.auth_new_password_aside_action(),
        to: "/login",
      }}
    >
      <NewPasswordForm token={token} />
    </AuthShell>
  );
}
